var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M2 6V3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v3l1 4v4.5a.5.5 0 1 1-1 0V13H2v1.5a.5.5 0 1 1-1 0V10l1-4zm0 5v1h12v-1H2zm10-5h1V3a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v3h1V5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1zm1.18 1H2.82L2 10h12l-.82-3zM5 5v1h6V5H5z" })
  );
});